export default __webpack_public_path__ + "static/media/Slider1.4045ac11.jpg";